<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary fixed :width="300">
      <v-list-item height="125px">
        <v-list-item-avatar>
          <v-avatar size="40" color="primary">
            <span class="white--text text-h6 ml-1 prevent-select">{{
              loggedInName | truncate(2)
            }}</span>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <p class="subtitle-1 font-weight-medium my-3 mx-3">
              {{ loggedInName }}
            </p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list rounded>
        <v-subheader class="prevent-select">Partner overzicht</v-subheader>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            color="primary"
            v-for="item in items"
            :key="item.title"
            link
            @click="navigateTo(item.routeName, item.external)"
            class="my-1"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-title>{{ item.subtitle }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="item.external">
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="pa-2">
          <v-btn block color="primary" @click="$auth.logout()"
            ><v-icon class="pr-1">mdi-logout</v-icon>Uitloggen</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
      :height="$vuetify.breakpoint.mdAndUp ? '125px' : '100px'"
    >
      <v-btn color="white" icon class="mx-2" @click="drawer = true"
        ><v-icon :size="40"> mdi-menu </v-icon></v-btn
      >
      <v-spacer></v-spacer>
      <v-img
        :src="require('../../assets/logo-material-handling.webp')"
        class="my-3 m-4 p-6 mr-0 pr-0 logo h-full"
        :max-width="$vuetify.breakpoint.mdAndUp ? '200px' : '125px'"
        contain
      />
      <v-img
        :src="require('@/assets/images/logo/logo-wit.webp')"
        class="my-3 m-4 p-6 mr-0 pr-0 logo h-full"
        :max-width="$vuetify.breakpoint.mdAndUp ? '200px' : '125px'"
        contain
      />
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { isEmptyObject } from "@/shared/utils/helpers";

export default {
  name: "PartnerLayout",
  data: () => ({
    drawer: null,
    items: [
      {
        title: "Agenda",
        icon: "mdi-calendar-month",
        routeName: "partnerPortalView",
        external: false,
      },
      {
        title: "Statistieken",
        icon: "mdi-chart-bar",
        routeName: "partnerPortalView",
        external: false,
      },
    ],
    selectedItem: 0,
    isEmptyObject,
  }),
  computed: {
    ...mapGetters({
      isDevelopment: "tools/getIsDevelopment",
      serverEnvironment: "tools/getServerEnvironment",
    }),
    loggedInName() {
      let currentUser = this.$auth.user();
      if (currentUser == null || this.isEmptyObject(currentUser)) return "";
      return currentUser.fullname.replace(/ /g, "") == ""
        ? currentUser.email
        : currentUser.fullname;
    },
  },
  mounted() {
    this.setCurrentNavigation();
  },
  methods: {
    navigateTo(name, external) {
      if (!external) this.$router.push({ name: name });
      else {
        window.open(name, "_blank", "noreferrer");
      }
    },
    setCurrentNavigation() {
      let currentRoutename = this.$router.currentRoute.name;
      let itemIndex = this.items.findIndex(
        (x) => x.routeName == currentRoutename
      );
      if (itemIndex < 0) this.selectedItem = 0;

      this.selectedItem = itemIndex;
    },
  },
};
</script>

<style scoped>
.prevent-select {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
